import { REVIEWS_WIDGET_NAMES } from "@/constants/widget-names";
import { ReviewsFormModalWidgetDefinition } from "@apps/reviews/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class ReviewsFormModalWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start(): void {
        this.logger.debug("ReviewsFormModalWidgetInjector start", {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger?.debug(
                "ReviewsFormModalWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const ReviewsFormModalWidget =
                    await this.dynamicImportManager.importDefault(
                        ReviewsFormModalWidgetDefinition
                    );

                const widget = new ReviewsFormModalWidget(
                    {
                        target: placeholder,
                    },
                    this.logger
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(
                        REVIEWS_WIDGET_NAMES.REVIEWS_FORM_MODAL_WIDGET
                    )
                );

                dispatchSdkEvent(
                    new WidgetInjectedSdkEvent(
                        REVIEWS_WIDGET_NAMES.REVIEWS_FORM_MODAL_WIDGET
                    )
                );
            })();
        });
    }
}

export default ReviewsFormModalWidgetInjector;
